import * as React from 'react';
import styles from './gfppBackgroundIcon.scss';

interface GfppBackgroundIconProps {
  iconInfo: React.CSSProperties & {
    underlayOpacity?: number;
    underlayBackgroundImage?: string;
  };
}

export const GfppBackgroundIcon: React.FC<GfppBackgroundIconProps> = ({
  iconInfo,
}) => {
  const {
    underlayOpacity,
    underlayBackgroundImage,
    backgroundColor,
    ...backgroundMediaProperties
  } = iconInfo;
  return (
    <div className={styles.container}>
      <div className={styles['empty-state']} />
      <div
        className={styles['fill-layer']}
        style={{
          backgroundColor,
          backgroundImage: underlayBackgroundImage,
          opacity: underlayOpacity ?? iconInfo.opacity,
        }}
      />
      {iconInfo.backgroundImage && (
        <div
          className={styles['media-container']}
          style={backgroundMediaProperties}
        />
      )}
    </div>
  );
};
